/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Product_Picker_Kiotviet_LinkedInputs */

const vi_product_picker_kiotviet_linked = /** @type {(inputs: Product_Picker_Kiotviet_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang nối: ${i?.label}`)
};

/**

* @param {Product_Picker_Kiotviet_LinkedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_picker_kiotviet_linked = /** @type {((inputs: Product_Picker_Kiotviet_LinkedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Picker_Kiotviet_LinkedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_picker_kiotviet_linked(inputs)
});